<template>
    <div class="SESuggestionsComponent dataTables"> 

               

        <b-container class="bv-example-row">
            <b-row>
                <b-col>
                    <AlternativeDetailsMainTableComponent :lang="lang.OverallDetails"></AlternativeDetailsMainTableComponent>
                    <AlternativeDetailsPropTableComponent :lang="lang.PropertiesDetails"></AlternativeDetailsPropTableComponent>
                </b-col>
                <b-col>
                    
                    <SEPropertiesChooseComponent :lang="lang.SEPropertiesChoose" :data="data"></SEPropertiesChooseComponent>
    
                    
                </b-col>
                
            </b-row>
        </b-container>

        
        
        

    </div>
</template>
<script>
    import AlternativeDetailsMainTableComponent from "@/components/shared/AlternativeDetailsMainTableComponent"
    import AlternativeDetailsPropTableComponent from "@/components/shared/AlternativeDetailsPropTableComponent"
    import SEPropertiesChooseComponent from "@/components/shared/SEPropertiesChooseComponent"

    
    
    import { mapGetters } from 'vuex'

    import $ from 'jquery';
    import dt from 'datatables.net-bs4';
    
    
    export default {
        name: "SESuggestionsComponent",
        props:{
          lang: Object,
          reloadTable: Boolean,
          data: Object
        },
        components: {
          AlternativeDetailsMainTableComponent,
          AlternativeDetailsPropTableComponent,
          SEPropertiesChooseComponent,
            
            
        },
        data () {
          return {
              name: "SESuggestionsComponent",
              mainTable: "",
              parts: [],

              searchTableInput: ""
          }
        },
        computed: {
          ...mapGetters({
            
            //appConf: 'appConf'

          }),
          id () {

            return "place_" + this.name
          },
          isData(){
             return this.data.length != 0
          },
            //   newRevision(){
            //       return this.data.newRevisionId == this.data.lockedRevisionId || this.data.newRevisionId == null;
            //   },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          }
        },
        created () {
          
        },
        mounted(){
            
            this.prepareData();
        },
        watch: {
          
        },
        updated() {
         
          
        },
        methods: {
            prepareData(){

                                
                this.parts = [];
                
                
                if (this.parts.length > 0){
                    this.buildTable();
                }
                
            },
          
            buildTable(){
            


                let tableplace = document.getElementById(this.id);

                if (tableplace == null){
                    return
                }
                while (tableplace.firstChild) {
                    tableplace.removeChild(tableplace.firstChild);
                }

                let table = document.createElement("table");
                table.setAttribute("id", "t_"+this.id);
                table.setAttribute("class", "table table-striped table-bordered");
                tableplace.appendChild(table)

                let tr = document.createElement("tr");
                tr.setAttribute("class", "cellHeader");
                let thead = document.createElement("thead");
                thead.appendChild(tr);
                table.appendChild(thead);

                let _vue = this;

                let columns = [
                    
                    {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",

                    },
                    {
                    name: this.lang.table_header_Status,
                    alignInColumn: "left",

                    },
                    {
                    name: this.lang.table_header_Description,
                    alignInColumn: "left",

                    },
                    

                ]

                let cols =  [
                    
                    { "data": "name" },
                    { "data": "status" },
                    { "data": "status" },

                ]


                let columnDefs = [];
                let len = columns.length;
                for (let i = 0; i < len; i++){
                    let widthCol = "30%";
                    if (i == 1){
                    widthCol = "70%"
                    }

                    let classname = '_dt-body-'+ columns[i].alignInColumn;

                    const el = {
                    targets: i,
                    //width: widthCol,
                    className: classname,

                    render: function ( data, type, row, meta ) {
                        if (data == null) {
                        data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                        data.display = $.fn.dataTable.render.text().display(data.display);
                        }


                        if(meta.col == 0){

                        return  data;

                        }
                        if (meta.col == 1) {
                        let d = data;
                        if (data.toLowerCase() == "updated" || data.toLowerCase() == "added" || data == "Successsfully uploaded to the server") {
                            d = "<div class=\"green ellipse\"></div><span class=\"hiddentext\">3</span>";
                        } else if (data.indexOf("Successful parsing") > -1) {
                            d = "<div class=\"yellow ellipse\"></div><span class=\"hiddentext\">2</span>";
                        } else {
                            d = "<div class=\"red ellipse\"><span class=\"hiddentext\">1</span></div>";
                        }
                        
                        return d;
                        }
                        if (meta.col == 2) {


                        return data;
                        }
                        
                        

                    },
                    

                    }

                    columnDefs.push(el);

                    

                    let th = document.createElement("th");
                    tr.appendChild(th);
                    let p = document.createElement("p");
                    th.appendChild(p);

                    let tx = document.createTextNode(columns[i].name)
                    p.appendChild(tx);

                }


                const json = {};
                json.paging = true;
                json.info = true;
                json.dom = 'f<t>ip';
                json.data= this.files;
                json.myColumnFormats = columns;
                json.select = false;
                json.order = [[1, "asc"]];
                json.lengthMenu = [16];
                json.columns = cols;

                json.columnDefs = columnDefs;
                json.initComplete = function () {
                    
                    
                    
                }

                if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
                    this.mainTable.destroy();
                    
                }

                

                this.mainTable = $('#t_'+this.id).DataTable(json);

                this.mainTable.columns.adjust().draw();

                //hide first column in table
                //this.mainTable.column( 0 ).visible( false );

                //search input change view
                var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

                while (searchplace.firstChild) {

                    if (searchplace.firstChild.textContent == "Search:"){
                        searchplace.removeChild(searchplace.firstChild);
                        break;
                    }

                }
                searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
                searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
  


            }
          
        }


    }
</script>
<style lang="scss">
  // @import "./../../scss/_theme.scss";
  // @import "./../../scss/_tables.scss";

  @import "./../../scss/_custom.scss";

  
  .SESuggestionsComponent {
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      width: 100% !important;
      margin-right: 10px;
      
    }
    table th {
      padding: 2px !important;
      min-width: 300px;
    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    table {
      .btn {
        padding: 0.15rem 0.5rem;
        margin: 2px;
      }
    }
    .ellipse{
      margin: 3px;
      height: 10px;
      width: 10px;
      border-radius: 50%;
    }
    .red {
      background-color: $red;
    }
    .green {
      background-color: $lightgreen;
    }
    .yellow {
      background-color: $yellow;
    }
    .hiddentext {
      font-size: 0px;
      float: left;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/shared/SESuggestionsComponent.vue